<template>
    <section class="relative overflow-hidden border-b border-green-600 bg-gray-100 dark:bg-gray-800">
        <PagesPageHeader
            :breadcrumbs="breadcrumbs"
            title="Agarwood Corporate"
            description="Venturing into owning and managing an agarwood plantation offers a path filled with potential rewards."
            icon="i-ion-business-outline"
            iconColor="green"
            color="blue"
            :image="true"
            src="/assets/images/sliders/slider-03.webp" />
    </section>

    <PagesCorporateMain />
    <PagesCalloutsPlantationOwnership />
</template>

<script setup>
    definePageMeta({
        layout: 'default'
    })

    const config = useRuntimeConfig()
    const router = useRouter()

    useHead({
        title: `${config.public.company.name} | Agarwood Corporate`,
        meta: [
            {
                name: 'description',
                content: 'Venturing into owning and managing an agarwood plantation offers a path filled with potential rewards.'
            },
            { name: 'robots', content: 'index, follow' }
        ],
        link: [{ rel: 'canonical', href: `${config.public.base.url + router.currentRoute.value.path}` }]
    })

    const breadcrumbs = [{ label: 'Home', to: '/' }, { label: 'Corporate' }]
</script>
